import moment from 'moment';
import { isAfterDay } from './isAfterDay';

export const isInclusivelyBeforeDay = (a?: moment.Moment, b?: moment.Moment): boolean => {
  if (!moment.isMoment(a) || !moment.isMoment(b)) return false;
  return !isAfterDay(a, b);
};
